import styled, { css } from "styled-components";

export const ContainerFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 0 0;
  gap: 12px;
`

export const MainOptionsModal = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`

const btnBase = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 0 18px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;
  border: none;
  white-space: nowrap;
`;

export const BtnClose = styled.button`
  ${btnBase}
  background-color: transparent;
  color: ${({ theme }) => theme.colors.textSecondary};
  border: 1px solid ${({ theme }) => theme.colors.lightGrayOpacity};

  &:hover {
    background-color: ${({ theme }) => theme.colors.lightGrayOpacity};
    color: ${({ theme }) => theme.colors.text};
  }
`;

export const BtnCancel = styled.button`
  ${btnBase}
  background-color: #D4764E18;
  color: #D4764E;
  border: 1px solid #D4764E40;

  &:hover {
    background-color: #D4764E30;
  }
`;

export const BtnSave = styled.button`
  ${btnBase}
  background-color: ${({ theme }) => theme.colors.success};
  color: #fff;

  &:hover {
    filter: brightness(0.9);
  }
`;
